export default {
    report: 'Report',
    dailyReport: 'Daily Report',
    monthlyReport: 'Monthly Report',
    empMonthlyLogReport: 'Employee Monthly Log Report',
    allBranch: 'All Branch',
    attendanceReport: 'Attendance',
    visitorReport: 'Visitor activity'
}
